const MuiCssBaseline = {
  styleOverrides: {
    'html, body': {
      height: '100%'
    }
  }
};
export default MuiCssBaseline;